export const borderWidth = 1;
export const borderRadius = 4;